<script>
    // @ts-nocheck
    export let value = null
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = null
    export let errorMsg = null
    export let name = null
    export let style = ''
    export let valid = null
    export let placeholder = ''
    export let options = []
    export let info = null
    export let overline = true
    export let searchable = true
    export let currentIndex = null
    export let maxItems = null
    export let strict = false
    let multi = true
    import { Typography, Chip } from '.'
    import { clickOutside, stringSimilarity } from '$lib/utils'
    import ScrollBox from './ScrollBox.svelte'
    import { getContext, onDestroy } from 'svelte'
    import slide from '../../custom/animations/slide'
    import { ChevronDown, InfoOutline } from '../Icons'
    import { createEventDispatcher } from 'svelte'
    import createDataStore from '../../stores/datastore'
    let formData = getContext('formData')
    let toggle = false
    let display = null
    let viewport = null
    let focus
    let currentOption = {}
    let vp = { height: 0, width: 0 }
    let _value = structuredClone(value)
    let filteredOptions = formatOptions(options)
    let initalValue =
        _value instanceof Array
            ? filteredOptions.filter((t) => _value.includes(t.value))
            : [filteredOptions.find((t) => t.value === _value) || false].filter(
                  (x) => x
              )
    const items = createDataStore(initalValue, (r) => r.value)
    let inputObj

    function refreshSearch(e = null) {
        let tmpval = e ? e.target.value : e
        if (e && tmpval !== null && tmpval !== '') {
            let search = formatedOptions.filter((o) =>
                `${o.label} ${o.value}`.match(
                    new RegExp(tmpval + '|' + tmpval.split(' ').join('|'), 'i')
                )
            )
            search.sort((a, b) => {
                return stringSimilarity(tmpval, a.label) >
                    stringSimilarity(tmpval, b.label)
                    ? -1
                    : 1
            })
            filteredOptions = search //.filter(t => !$items?.map(x => x.value)?.includes(t.value));
            // filteredOptions = formatedOptions.filter(o => searchFilterSimilarity(`${o.label} ${o.value}`, tmpval, 0.61))
        } else {
            filteredOptions = formatedOptions //.filter(t => !$items?.map(x => x.value)?.includes(t.value));
        }
    }

    function formatOptions(inp) {
        let ret = []
        if (inp instanceof Array) {
            for (let term of inp) {
                if (typeof term == 'object') {
                    let { label, value } = term
                    if (label && value !== undefined) ret.push({ label, value })
                } else if (term instanceof Array && term.length == 2) {
                    let [label, value] = term
                    ret.push({ label, value })
                } else if (
                    ['number', 'string', 'boolean'].includes(typeof term)
                ) {
                    ret.push({ label: String(term), value: term })
                }
            }
        }
        return ret
    }

    // @ts-ignore

    const dispatch = createEventDispatcher()
    // @ts-ignore
    function onchange() {
        dispatch('change', {})
    }
    // @ts-ignore
    function onkeypress() {
        dispatch('keypress', {})
    }
    // @ts-ignore
    function onkeyup() {
        dispatch('keyup', {})
    }
    // @ts-ignore
    function ontype() {
        dispatch('type', {})
    }
    function onblur() {
        dispatch('blur', {})
    }
    function keypress(event) {
        if (['Enter', 'Space'].indexOf(event.code) !== -1 && !toggle) {
            toggle = true
        } else if (event.code === 'Escape') {
            toggle = false
        } else if (event.code === 'ArrowDown') {
            event.preventDefault()
            if (currentIndex + 1 < options.length && !disabled) {
                value = options[currentIndex + 1]?.value || null
            }
        } else if (event.code === 'ArrowUp' && !disabled) {
            event.preventDefault()
            if (currentIndex - 1 >= 0) {
                value = options[currentIndex - 1]?.value || null
            }
        }
    }

    function getOption() {
        let index = formatedOptions?.findIndex((x) => x.value === value)
        return index !== -1 ? { ...formatedOptions[index], index } : null
    }

    // Two way binding value
    $: _value = multi
        ? $items?.map((x) => x.value) || []
        : $items?.length > 0
          ? $items[0].value
          : null
    $: if (
        JSON.stringify(value) !== JSON.stringify(_value) ||
        value != _value
    ) {
        console.log('CHANGE')
        let tval =
            value instanceof Array
                ? filteredOptions.filter((t) => value.includes(t.value))
                : [
                      filteredOptions.find((t) => t.value === value) || false,
                  ].filter((x) => x)
        let n = tval.length
        items.set([])
        if (maxItems !== null) {
            items.set(maxItems >= tval.length ? tval : tval.slice(n - maxItems))
        } else {
            items.set(tval)
        }
        display = ''
    }
    $: value = _value

    $: formatedOptions = formatOptions(options)
    $: if (value) {
        valid = value && validation ? validation(value) : true
        currentOption = getOption()
    }
    $: currentIndex = currentOption?.index || -1
    $: if (!disabled) toggle = false

    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: !!valid,
                            validation: !!validation,
                            required,
                            value,
                            label,
                            labelOption: display,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    // if(!multi) maxItems = 1
    if (display && display?.length === 0) filteredOptions = formatOptions
    // $: filteredOptions = formatedOptions
    let tmp_ = JSON.stringify(currentOption)
    $: if (JSON.stringify(currentOption) !== tmp_) {
        display = !multi ? currentOption?.label : ''
        tmp_ = JSON.stringify(currentOption)
    }
    // @ts-ignore
    // $: if ([undefined, null, ''].includes(currentOption) || !!!value) {
    //   if(!multi){ display = ''}
    // }
    let inpFocus = false
    // $: if (inpFocus === true && $items.length) toggle = true
    function change(newVal) {
        if (items.exists(newVal?.value || newVal)) return
        if (maxItems !== null && items.count() < maxItems) {
            if(strict && currentOptions.map(x => x.value).includes(newVal)) {
                items.add(newVal)
            } else {
                items.add(newVal)
            }
        } else {
            items.set($items.slice(1).concat([newVal]))
        }
    }
    // $: inpProps = $items.length >= 1 ? {size: display?.length + 1} : { style: 'position: relative; width: calc(100%-0px)'};
    $: currentOptions = multi
        ? filteredOptions.filter(
              (t) => !$items?.map((x) => x.value)?.includes(t.value)
          )
        : formatedOptions
    $: if (focus === true) {
        inputObj.focus()
    }
    // $: console.log({inpProps})
</script>

<div
    {style}
    class="box"
    class:disabled
    on:mouseover={(_) => (focus = true)}
    on:mouseout={(_) => (focus = false)}
    on:focus={(_) => (focus = true)}
    on:blur={(_) => (focus = false)}
>
    {#if label}
        <div
            style="position: relative; display: flex; gap: 7px; align-items: center; margin-bottom: 16px"
        >
            <Typography
                style="margin: 0;"
                type="caption"
                color={disabled ? 'grey-300' : 'black'}>{label}</Typography
            >
            {#if required && !disabled && !value}
                <InfoOutline
                    size={16}
                    style="cursor: pointer"
                    title="Campo requerido."
                />
            {/if}
        </div>
    {/if}
    <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
    <div
        tabindex="0"
        on:click={(_) => {
            if (!disabled && !multi) toggle = !toggle
            inputObj.focus()
        }}
        use:clickOutside
        on:clickout={(_) => {
            toggle = false
            onblur()
        }}
        on:keyup={keypress}
        on:focus={(_) => (focus = true)}
        on:blur={(_) => (focus = false)}
        on:click={(_) => {
            if ($items.length == 0) toggle = !toggle
        }}
        style="position: relative; display: flex; cursor: pointer; gap: 12px; justify-content: space-between; align-items: center; width: 100%"
    >
        <!-- on:keypress="{keypress}" -->
        <span
            style="display: flex; gap: 5px; flex-wrap: wrap; padding: 0 0 8px 0"
        >
            <input
                type="text"
                size={Math.ceil(
                    display
                        ? 0.8 * (display?.length || 1)
                        : !$items.length
                          ? 0.8 * placeholder?.length || 1
                          : 2
                )}
                disabled={disabled || !searchable}
                placeholder={!$items.length ? placeholder : undefined}
                bind:value={display}
                on:focus={() => (inpFocus = true)}
                on:blur={() => (inpFocus = false)}
                on:keyup={(e) => {
                    toggle = true
                    refreshSearch(e)
                }}
                bind:this={inputObj}
                class:multi
                autocomplete="off"
            />
            {#if multi}
                {#each $items as item (item)}
                    <Chip
                        style="border-radius: 5px"
                        color={`rgba(194, 27, 23, ${disabled ? '0.3' : '1'})`}
                        label={item.label}
                        closeable={!disabled}
                        on:close={() => items.delete(item.value)}
                    />
                {/each}
            {/if}
        </span>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <i
            on:click={() => {
                if (!disabled && multi) toggle = !toggle
            }}
        >
            <ChevronDown
                color={disabled || currentOptions.length == 0
                    ? '#CCCCCC'
                    : '#6F7072'}
            />
        </i>
        {#if !disabled && toggle && currentOptions.length > 0}
            <div
                on:blur={(_) => {
                    toggle = false
                }}
                transition:slide
                class="optionBox"
                bind:this={viewport}
                bind:clientWidth={vp.width}
                bind:clientHeight={vp.height}
            >
                <ScrollBox
                    width="100%"
                    height={currentOptions.length >= 5
                        ? '235px'
                        : `${currentOptions.length * 47}px`}
                >
                    {#if currentOptions.length > 0}
                        <ul>
                            {#each currentOptions as opt (opt.value)}
                                <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
                                <li
                                    tabindex="0"
                                    class:active={value === opt.value}
                                    on:keypress={(e) => {
                                        if (e.code === 'Enter') {
                                            change(opt)
                                            toggle = false
                                            display = !multi ? opt?.label : ''
                                            refreshSearch()
                                        }
                                    }}
                                    on:click={(_) => {
                                        change(opt)
                                        display = !multi ? opt?.label : ''
                                        refreshSearch()
                                    }}
                                >
                                    <Typography
                                        type="body"
                                        style="margin: 0; padding: 0"
                                        color="grey-800">{opt.label}</Typography
                                    >
                                </li>
                            {/each}
                        </ul>
                    {:else}
                        No options
                    {/if}
                </ScrollBox>
            </div>
        {/if}
    </div>
    <span
        class={!valid && validation && value && !disabled ? 'error' : ''}
        style={`${(!valid && errorMsg && !disabled) || info ? 'padding: 11px 0;' : ''}; ${overline ? `border-top: 1px var(--color-grey-${focus && !disabled ? '800' : '300'}) solid` : ''}`}
    >
        {#if value && validation && !valid && errorMsg && !disabled}
            <Typography type="label" style="margin: 0">{errorMsg}</Typography>
        {:else if info && !disabled}
            <Typography type="caption" color="grey-300" style="margin: 0"
                >{info}</Typography
            >
        {/if}
    </span>
</div>

<style>
    .box {
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        user-select: none;
    }
    input[type='text'].multi {
        height: 25px;
    }
    input[type='text'] {
        background: transparent;
        padding: 0 0 11px 5px;
        border-style: none;
        margin: 0;
        font-size: 17px;
        /* width: fit-content; */
        /* line-height: 22px; */
        color: var(--color-black);
        outline: none;
        cursor: pointer;
        caret-color: #5496e3;
        caret-shape: bar;
    }
    input[type='text']::placeholder {
        color: var(--color-grey-300);
    }
    span {
        width: 100%;
        display: flex;
        transition: all 0.2s ease-in-out;
    }

    .error {
        border-top: 1px var(--color-accent-alert-error) solid;
        color: var(--color-accent-alert-error);
        background: var(--color-accent-alert-error-bg);
    }

    .disabled {
        cursor: no-drop;
    }

    .disabled span {
        /* border-top: 1px var(--color-grey-300) solid; */
        cursor: no-drop;
    }

    .disabled input[type='text']:disabled {
        color: var(--color-grey-400);
    }

    .optionBox {
        width: 100%;
        position: absolute;
        min-height: 22px;
        max-height: calc(5 * 47px);
        top: calc(100% + 1px);
        background: #ffffff;
        box-shadow:
            0px 2px 4px rgba(0, 0, 0, 0.2),
            0px -1px 1px rgba(0, 0, 0, 0.02);
        z-index: var(--lvl-4);
        overflow-y: scroll;
    }
    .optionBox::-webkit-scrollbar {
        display: none;
    }
    .optionBox ul {
        width: 100%;
        margin: 0;
        padding: 0;
        height: auto;
        display: flex;
        flex-direction: column;
        list-style: none;
    }
    .optionBox li {
        width: 100%;
        height: 47px;
        display: flex;
        align-items: center;
        padding-left: 19px;
        list-style: none;
        background: var(--color-white);
        transition: all 0.2s ease-in-out;
    }

    .optionBox li.active,
    .optionBox li:hover {
        background: var(--color-grey-050);
    }
</style>
